export const HeaderScroll = () => {
  
  let lastScrollTop = 0
  
  const header = document.querySelector('#header')
  
  window.addEventListener('scroll', () => {
    
    let st = window.pageYOffset || document.documentElement.scrollTop
    if (st > 200 && st > lastScrollTop){
      if (!header.classList.contains('header--scroll')) {
        header.classList.add('header--scroll')
      }
    } else {
      if (header.classList.contains('header--scroll')) {
        header.classList.remove('header--scroll')
      }
    }
    lastScrollTop = st <= 0 ? 0 : st // For Mobile or negative scrolling
    
  }, {passive: true})
}
